import { render, staticRenderFns } from "./RESP.vue?vue&type=template&id=2298dfda"
import script from "./RESP.vue?vue&type=script&lang=js"
export * from "./RESP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports